export default "__VITE_ASSET__jVM2Tum$__"